import type { ButtonProps, ButtonVariant } from "../types/components.js";

const variants = {
  primary:
    "border border-transparent bg-primary text-primary-foreground shadow-xs hover:bg-primary/90 disabled:opacity-50",
  secondary:
    "border border-input bg-secondary text-secondary-foreground shadow-xs hover:bg-muted disabled:opacity-50",
  tertiary: "border border-transparent bg-transparent text-foreground hover:bg-muted disabled:text-disabled",
  ghost: "border border-transparent bg-transparent text-foreground hover:bg-muted disabled:text-disabled",
  danger:
    "border border-destructive-foreground/10 bg-destructive text-destructive-foreground hover:bg-destructive/80 disabled:opacity-50",
  success:
    "border border-success-foreground/10 bg-success text-success-foreground shadow-xs hover:bg-success/80 disabled:opacity-50",
} as const;

const buttonBaseClassName =
  "inline-flex min-h-10 items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/30 disabled:cursor-not-allowed";

export function buttonClassName(variant: ButtonVariant = "primary", className = "") {
  return `${buttonBaseClassName} ${variants[variant]} ${className}`.trim();
}

export function Button({ controlId, variant = "primary", className = "", ...props }: ButtonProps) {
  return <button data-control-id={controlId} className={buttonClassName(variant, className)} {...props} />;
}
